/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { hooksServerNamesListServerNameOverrides } from "../funcs/hooksServerNamesListServerNameOverrides.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ServerNameOverride } from "../models/components/servernameoverride.js";
import {
  ListServerNameOverridesRequest,
  ListServerNameOverridesSecurity,
} from "../models/operations/listservernameoverrides.js";
import { unwrapAsync } from "../types/fp.js";
export type HooksServerNamesListServerNameOverridesQueryData = Array<
  ServerNameOverride
>;

export function prefetchHooksServerNamesListServerNameOverrides(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListServerNameOverridesRequest | undefined,
  security?: ListServerNameOverridesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildHooksServerNamesListServerNameOverridesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildHooksServerNamesListServerNameOverridesQuery(
  client$: GramCore,
  request?: ListServerNameOverridesRequest | undefined,
  security?: ListServerNameOverridesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<HooksServerNamesListServerNameOverridesQueryData>;
} {
  return {
    queryKey: queryKeyHooksServerNamesListServerNameOverrides({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function hooksServerNamesListServerNameOverridesQueryFn(
      ctx,
    ): Promise<HooksServerNamesListServerNameOverridesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(hooksServerNamesListServerNameOverrides(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyHooksServerNamesListServerNameOverrides(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "hooksServerNames",
    "listServerNameOverrides",
    parameters,
  ];
}
